/* __next_internal_client_entry_do_not_use__ BrandPageBrandViewContext,useBrandPageBrandViewContext,BrandPageBrandViewClientContextProvider auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { IBrandViewV2Response } from "@faire/web-api--source/indigofair/data/IBrandViewV2Response";
import React, { useContext } from "react";
import { useFetchCachedBrandView } from "../hooks/useFetchCachedBrandView";
var DEFAULT_BRAND_PAGE_BRAND_VIEW_STATE = {
    brandViewLegacy: IBrandViewV2Response.build({}),
    brandViewPromise: Promise.resolve(undefined)
};
export var BrandPageBrandViewContext = /*#__PURE__*/ React.createContext(DEFAULT_BRAND_PAGE_BRAND_VIEW_STATE);
export var useBrandPageBrandViewContext = function() {
    var value = useContext(BrandPageBrandViewContext);
    if (value === DEFAULT_BRAND_PAGE_BRAND_VIEW_STATE) {
        throw new Error("useBrandPageBrandViewContext must be used within a BrandPageBrandViewContext.Provider");
    }
    return value;
};
export var BrandPageBrandViewClientContextProvider = function(param) {
    var brandToken = param.brandToken, children = param.children;
    var _useFetchCachedBrandView = useFetchCachedBrandView(brandToken), brandViewData = _useFetchCachedBrandView.data;
    return /*#__PURE__*/ _jsx(BrandPageBrandViewContext.Provider, {
        value: {
            brandViewLegacy: brandViewData
        },
        children: children
    });
};
